import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import TagFilters from "views/pages/tag/filters";
import CreateNewTag from "views/pages/tag/create-new-tag";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import {
  getList,
} from "actions/tag/actions";
import useSearchHook from "hooks/useSearch.hook";

const Tag = (props) => {
  const {
    loading,
    list,
    getList,
    pages
  } = props;
  const {
    page,
    size,
    filters,
    handleSearch,
    handleReset,
    handlePageChange,
    handleSortedChange,
    handlePageSizeChange
  } = useSearchHook(getList, {
    size: 30,
    sort: "date,desc"
  });

  const handleCreate = (tagId = false) => {
    const modalObj = {
      modalSettings: {
        size: "sm",
      },
      header: `${tagId ? "Update" : "Create"} Tag`,
      children: (
        <CreateNewTag
          onCancel={() => props.closeCustomModal(modalObj)}
          tagId={tagId}
        />
      ),
      handleClose: () => props.closeCustomModal(modalObj)
    };
    props.openCustomModal(modalObj);
  };

  const getColumns = () => [
    {
      Header: "#",
      accessor: "id",
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Type",
      accessor: "type",
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <button
          className="btn btn-sm btn-warning"
          onClick={() => handleCreate(original.id)}
        >
          <FontAwesomeIcon icon={faPencilAlt}/>
        </button>
      )
    },
  ];

  return (
    <div className="w-100 p-2">
      <div className="filters">
        <TagFilters
          activeFilters={filters}
          totalCount={list.total_count || 0}
          handleSearch={handleSearch}
          handleReset={handleReset}
          handleCreate={() => handleCreate()}
        />
      </div>

      <ReactTable
        data={list.content || []}
        headerClassName="table-header"
        columns={getColumns()}
        pageSizeOptions={[10, 20, 50, 100]}
        resizable
        className="-striped -highlight table-header-padding"
        loading={loading}
        filterable={false}
        defaultFilterMethod={filterCaseInsensitive}
        style={{
          height: "calc(100vh - 140px)"
        }}
        manual={true}
        pages={pages}
        page={page}
        pageSize={size}
        onSortedChange={handleSortedChange}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  loading: state.tag.loading,
  list: state.tag.tagList,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getList: bindActionCreators(getList, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Tag);



// WEBPACK FOOTER //
// ./src/views/pages/tag/index.js